// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import { SecondaryLink } from '../buttons';

type Props = {
  header?: string;
  headerIcon?: string;
  body?: React.ReactNode;
  actionLabel?: string;
  onAction?: () => void;
  actionIcon?: string;
  disableAction?: boolean;
  dark?: boolean;
};

const GenericEmptyState = ({ header, headerIcon, body, actionLabel, onAction, actionIcon, disableAction, dark, ...rest }: Props) => (
  <div className={classNames('generic-empty-state', { dark })}>
    {header && (
      <h1>
        {headerIcon && <i className={headerIcon} />}

        {header}
      </h1>
    )}

    <span className="empty-state-body">{body}</span>

    {actionLabel && (
      <SecondaryLink onClick={onAction} disabled={disableAction}>
        <span>{actionLabel}</span>
        {actionIcon && <i className={actionIcon} />}
      </SecondaryLink>
    )}
  </div>
);

export default GenericEmptyState;
